<template>
  
  <div class="category-demo">
    <h2>同一本添加到多个不同分类标签的选择效果</h2>

    <div class="demo-section">
      系列名称；
      <el-input
          class="search-input"
          placeholder="请输入书籍系列名称"
          v-model="searchKeyword"
      />
      <div style="height:20px;"></div>

      <category-selector
        v-model="selectedIds"
        :category-data="categoryData"
        placeholder="请选择分类"
        @change="handleChange"
      />
    </div>
  </div>
</template>

<script>
import CategorySelector from './CategorySelector.vue';

export default {
  name: 'CategoryDemo',
  components: {
    CategorySelector
  },
  data() {
    return {
      searchKeyword: '',
      // 分类数据
      categoryData: [
        {
          id: 1,
          label: '边疆文献',
          children: []
        },
        {
          id: 2,
          label: '海疆文献',
          children: []
        },
        {
          id: 3,
          label: '民族融合文献',
          children: [
            { id: 300000001, label: '维吾尔族' },
            { id: 300000002, label: '壮族' },
            { id: 300000003, label: '蒙古族' },
            { id: 300000004, label: '回族' },
          ]
        },
        {
          id: 4,
          label: '明代文献',
          children: []  // 没有二级分类
        },
        {
          id: 5,
          label: '清代文献',
          children: []
        },
        {
          id: 6,
          label: '地方志',
          children: []
        },
        {
          id: 7,
          label: '期刊报纸（有年份差别）',
          children: [
            { id: 700000001, label: '2013年' },
            { id: 700000002, label: '2014年' },
            { id: 700000003, label: '2015年' },
            { id: 700000004, label: '2016年' },
            { id: 700000005, label: '2017年' },
            { id: 700000006, label: '2018年' }
          ]
        },
        {
          id: 8,
          label: '东南亚文献',
          children: []  // 没有二级分类
        },
        {
          id: 9,
          label: '南亚文献',
          children: []  // 没有二级分类
        },
        {
          id: 10,
          label: '东北亚文献',
          children: []  // 没有二级分类
        },
        {
          id: 11,
          label: '中国周边关系文献',
          children: []  // 没有二级分类
        },
        {
          id: 12,
          label: '一带一路',
          children: []  // 没有二级分类
        },
        {
          id: 13,
          label: '区域国别文献',
          children: []  // 没有二级分类
        },
        {
          id: 14,
          label: '各国馆藏文献',
          children: []  // 没有二级分类
        },
        {
          id: 15,
          label: '域外古籍',
          children: []  // 没有二级分类
        },
        {
          id: 16,
          label: '传世医学',
          children: []  // 没有二级分类
        },
        {
          id: 17,
          label: '考古古物',
          children: []  // 没有二级分类
        },
        {
          id: 18,
          label: '中国农学遗产文献',
          children: []  // 没有二级分类
        },
        {
          id: 19,
          label: '商业经济文献',
          children: []  // 没有二级分类
        },
        {
          id: 20,
          label: '专题史料文献',
          children: []  // 没有二级分类
        }
      ],

      // 选中的ID
      selectedIds: [1,2],
      // selectedIds: [14,1,21,2,3,4,1023,102,103],   //重点：从数据库中获取上次保存的值，进行初始化的处理

      // 选中的节点信息
      selectedNodes: [],

    };
  },
  computed: {

  },
  methods: {
    // 事件处理
    handleChange(data) {
      this.selectedNodes = data.nodes;
      console.log('选择变化:', data);
    },
  }
};
</script>

<style scoped>
.category-demo {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
}

.demo-section {
  margin-bottom: 30px;
  padding: 25px;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  background: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.demo-section h3 {
  margin-top: 0;
  margin-bottom: 20px;
  color: #606266;
  border-left: 4px solid #409eff;
  padding-left: 10px;
}

</style>


// WEBPACK FOOTER //
// src/views/ztestapp/index.vue